/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import { func, string } from 'prop-types';
import errorIcon from 'Assets/images/commons/error.svg';

const ErrorIcon = ({ onClick, icon }) => (
  <img
    style={{ cursor: onClick ? 'pointer' : 'default' }}
    src={icon || errorIcon}
    alt="error icon"
    onClick={onClick}
  />
);

ErrorIcon.propTypes = {
  onClick: func,
  icon: string,
};
ErrorIcon.defaultProps = {
  onClick: () => null,
  icon: '',
};

export default ErrorIcon;
